import { Loadable } from '@gdp/react-app/lib/helpers/loadable';

export const LoadableDriverRoutes = Loadable(
  './DriverRoutes',
  () => import(/* webpackChunkName: "Driver" */ './DriverRoutes'),
  () => [(require as any).resolveWeak('./DriverRoutes')]
);
